export const initialState = {
  userFormData: [],
  formsData: [],
}

export const formManagerReducer = (state, action) => {
  switch (action.type) {
    case 'SET_USERFORMDATA':
      return { ...state, userFormData: action.userFormData }
    case 'SET_FORMSDATA':
      return { ...state, formsData: action.formsData }
    default:
      return state
  }
}
